<div class="loginView verticalCenterView">
    <div class="loginView__logo">
        <img id="logo" src="https://wickedlist.com/assets/img/logo.png" />
    </div>

    <div class="loginView__buttonsWrap" *ngIf="view === 0">
        <div class="loginView__btLogin">
            <button mat-raised-button color="primary" (click)="changeView(1)">Login</button>
        </div>
        <div class="loginView__btRegister">
            <a mat-raised-button color="primary" [routerLink]="['/register']">Register</a>
        </div>
        <div class="loginView__btBack">
            <a mat-raised-button color="primary" (click)="locationBack()">Back</a>
        </div>
    </div>

    <form class="loginForm loginView__loginForm" *ngIf="view !== 0" [formGroup]="loginForm">
        
        <div class="loginForm__fieldsContainer" *ngIf="!loading">
            <mat-form-field class="loginForm__email">
                <mat-label>Email</mat-label>
                <input matInput type="text" formControlName="email" required>
            </mat-form-field>

            <mat-form-field class="loginForm__password">
                <mat-label >{{passwordInput.value ? 'Password' : 'Enter your password'}}</mat-label>
                <input matInput [type]="showPassword ? 'password' : 'text'" formControlName="password" required>
                <mat-icon matSuffix (click)="showPassword = !showPassword">{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </mat-form-field>

            <div class="loginForm__rememberme" *ngIf="false">
                <div class="col">
                    <mat-checkbox formControlName="rememberme" color="primary">Remember me</mat-checkbox>
                </div>
            </div>

            <div class="loginForm__resetPassword">
                <a class="link" (click)="closeAction()" routerLink="/reset-password">
                    Forgot your password ?
                </a>
            </div>

            <div class="loginForm__captcha">
                <re-captcha (resolved)="captchaResolved($event)" *ngIf="this.captchaAvailable()"
                            [siteKey]="this.service.captchaService.getCurrentCaptchaKey()"> </re-captcha>
            </div>
       
        </div>

        <div class="loginView__loader" *ngIf="loading"><mat-spinner diameter="36" ></mat-spinner></div>

        <button class="loginForm__submit" type="submit" mat-raised-button color="primary" (click)="onSubmit()">Login</button>

        <div class="loginView__btBack">
            <a mat-raised-button color="primary" (click)="changeView(0)">Back</a>
        </div>
    </form>
</div>
